module.exports = __webpack_public_path__ + "img/marvelstudios.e44c5a9e.svg";